<h1 mat-dialog-title>{{title}} <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
</sfc-icon></h1>
<div mat-dialog-content>
  <table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
    <ng-container matColumnDef="claimAmount">
      <th mat-header-cell *matHeaderCellDef> Bedrag vordering</th>
      <td mat-cell [ngClass]="{'red': data.claimAmount < 0}" *matCellDef="let data">{{getAmount(data.claimAmount, 'EUR')}}</td>
    </ng-container>

    <ng-container matColumnDef="mutationAmount">
      <th mat-header-cell *matHeaderCellDef> Bedrag mutatie</th>
      <td mat-cell *matCellDef="let data">{{getAmount(data.mutationAmount, 'EUR')}}</td>
    </ng-container>

    <ng-container matColumnDef="mutationReason">
      <th mat-header-cell *matHeaderCellDef> Reden mutatie</th>
      <td mat-cell *matCellDef="let data">{{data.mutationReason ? data.mutationReason : emptyValuePlaceholder}}</td>
    </ng-container>

    <ng-container matColumnDef="processingDate">
      <th mat-header-cell *matHeaderCellDef> Datum verwerkt</th>
      <td mat-cell *matCellDef="let data">{{data.processingDate ? data.processingDate : emptyValuePlaceholder}}</td>
    </ng-container>

    <ng-container matColumnDef="outstandingClaimAmount">
      <th mat-header-cell *matHeaderCellDef> Bedrag openstaand</th>
      <td mat-cell [ngClass]="{'red': data.totalOutstandingAmount < 0}" *matCellDef="let data">{{getAmount(data.totalOutstandingAmount, 'EUR')}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
  </table>
  <ng-template #errorTextField>
    <div class="error-text">
      {{errorText}}
    </div>
  </ng-template>
</div>

